<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="780px">
		<v-card>
			<v-card-title class="headline">
				<v-icon>note_add</v-icon> Nueva Solicitud {{ horas_disponibles === null ? '' : `Tiene ${horas_disponibles.toFixed(2)} horas disponibles`}}
				<v-spacer></v-spacer>
				<v-btn icon @click="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation>
				<v-card-text class="pt-0">
					<v-container grid-list-md class="pt-0">
						<v-layout row wrap>
							<v-flex xs12>
								<v-select
									label="Tipo de papeleta"
									:items="permisos"
									v-model="permiso.id_tipo_permiso"
									:rules="$validate(['required'])"
									item-value="id"
									item-text="descripcion"
									required
									autofocus
									:disabled="permiso_detalles.length > 0"
								/>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									label="Motivo"
									v-model="permiso.motivo"
									:disabled="permiso_detalles.length > 0"
									:rules="$validate(['required'])"
									required
								></v-textarea>
							</v-flex>
						</v-layout>
						<h4 v-if="horas_disponibles > 0">Detalle de papeleta</h4>
						<v-layout>
							<v-flex xs6>
								<v-text-field
									v-model="form.fecha_desde"
									type="date"
									label="Fecha salida"
									:rules="$validate(['required'])"
									required
									@change="validarPermiso()"
								/>
							</v-flex>
							<v-flex xs6>
								<v-text-field
									v-model="form.fecha_hasta"
									type="date"
									label="Fecha salida"
									:rules="$validate(['required'])"
									required
									@change="validarPermiso()"
								/>
							</v-flex>
						</v-layout>
						<v-layout
							v-if="horas_disponibles > 0"
						>
							<v-flex xs6>
								<v-menu
									ref="menu_desde"
									v-model="menu2_hora_desde"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="time_hora_desde"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="time_hora_desde"
											label="Hora desde"
											prepend-icon="access_time"
											readonly
											v-on="on"
											:rules="$validate(['required'])"
										></v-text-field>
									</template>
									<v-time-picker
										format="24hr"
										:allowed-minutes="allowedStep"
										v-if="menu2_hora_desde"
										v-model="time_hora_desde"
										full-width
										@click:minute="$refs.menu_desde.save(time_hora_desde)"
									></v-time-picker>
								</v-menu>
							</v-flex>
							<v-flex xs6>
								<v-menu
									ref="menu_hasta"
									v-model="menu2_hora_hasta"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="time_hora_hasta"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="time_hora_hasta"
											label="Hora desde"
											prepend-icon="access_time"
											readonly
											v-on="on"
											:rules="$validate(['required'])"
										></v-text-field>
									</template>
									<v-time-picker
										format="24hr"
										:allowed-minutes="allowedStep"
										v-if="menu2_hora_hasta"
										v-model="time_hora_hasta"
										full-width
										@click:minute="$refs.menu_hasta.save(time_hora_hasta)"
									></v-time-picker>
								</v-menu>
							</v-flex>
						</v-layout>
						<v-layout
							v-if="horas_disponibles > 0"
						>
							<v-flex xs6>
								<v-btn
									color="primary"
									:loading="loading"
									@click.prevent="addPermisoDetalle()"
								>
								<v-icon>add</v-icon>
									Adicionar
								</v-btn>
								<span v-if="permiso_detalles.length > 0">
									Total horas solicitadas: {{ horas_solicitadas.toFixed(2) }}
								</span>
							</v-flex>
							<v-flex xs6>
								<v-alert
									:value="true"
									type="error"
									v-if="horas_solicitadas > horas_disponibles"
								>
									Superó sus horas disponibles
								</v-alert>
							</v-flex>
						</v-layout>
						<v-layout
							v-if="horas_disponibles > 0"
						>
							<v-flex xs12>
								<v-data-table
									:items="permiso_detalles"
									class="elevation-1"
									hide-actions
									:headers="headers"
								>
									<template v-slot:items="props">
										<td class="text-xs-center">{{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}</td>
										<td class="text-xs-center">{{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}</td>
										<td class="text-xs-center">{{ props.item.hora_desde }}</td>
										<td class="text-xs-center">{{ props.item.hora_hasta }}</td>
										<td class="text-xs-center">{{ ($moment(props.item.fecha_hasta+' '+props.item.hora_hasta).diff(props.item.fecha_desde+' '+props.item.hora_desde, 'minutes') / 60).toFixed(2) }}</td>
										<td class="text-xs-center">
											<v-btn
												color="error"
												icon
												title="Eliminar"
												@click.prevent="deletePermisoDetalle(props.item.delete)"
											>
												<v-icon>delete</v-icon>
											</v-btn>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions
					v-if="horas_disponibles > 0"
				>
					<small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn @click="close()"><v-icon>cancel</v-icon> {{$t('common.cancel') }}</v-btn>
					<v-btn
						color="primary"
						type="submit"
						:disabled="!permiso_detalles.length > 0 || (horas_solicitadas > horas_disponibles)"
						:loading="loading"
					><v-icon>check</v-icon> 
						{{$t('common.save') }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate';

export default {
	mixins: [validate ],
	mounted () {
		this.$bus.$on('openDialogAdd', () => {
			this.dialog = true
		})
		this.getTipoPermisos()
	},
	data () {
		return {
			dialog: false,
			form: {},
			permiso: {
				id_tipo_permiso: null,
				motivo: ''
			},
			permisos: [],
			permiso_detalle: {},
			valid: false,

			time_hora_desde: null,
      menu2_hora_desde: false,
      modal2_hora_desde: false,

			time_hora_hasta: null,
      menu2_hora_hasta: false,
      modal2_hora_hasta: false,
			loading: false,
			headers: [
				{
					text: 'Fecha salida',
					sortable: false
				},
				{
					text: 'Fecha hasta',
					sortable: false
				},
				{
					text: 'Hora desde',
					sortable: false
				},
				{
					text: 'Hora hasta',
					sortable: false
				},
				{
					text: 'Total Horas',
					sortable: false
				},
				{
					text: 'Acción',
					sortable: false
				}
			],
			permiso_detalles: [],
			registro_permiso: false,
			count_id: 0,
			horas_disponibles: null,
			horas_solicitadas: 0
		}
	},
	methods: {
		allowedStep: m => m % 5 === 0,
		async getTipoPermisos () {
			try {
				let res = await this.$service.graphql({
					query: `
						query {
							tipoPermisos(id_estado: 19) {
							rows {
								id
								descripcion
								refrigerio
								tiempo_maximo
								tiempo_minimo
								estado {
									descripcion
									abrev
								}
							}
						}
					}
					`
				})
				if (res) {
					this.permisos = res.tipoPermisos.rows
				}
			} catch (error) {
				console.log(error)
			}
		},
		async validarPermiso () {
			if (this.$refs.form.validate()) {
				const user = this.$storage.get('user')
				try {
					let res = await this.$service.graphql({
						query: `
							query {
								runQuery(consulta: "SELECT control.fn_valida_permiso(${user.id_persona}, '${this.form.fecha_desde}', ${this.permiso.id_tipo_permiso})"){
									respuesta
								}
							}
						`
					})
					if (res) {
						this.horas_disponibles = parseFloat(res.runQuery.respuesta[0].fn_valida_permiso)
					}
					this.form.fecha_hasta = this.form.fecha_desde
				} catch (error) {
					console.log(error)
				}
			}
		},
		close () {
			this.dialog = false
			this.permiso = {
				id_tipo_permiso: null,
				motivo: ''
			}
			this.$bus.$emit('closeDialogAddpermiso')
			this.time_hora_desde = null
			this.time_hora_hasta = null
			this.permiso_detalles = []
			this.count_id = 0
			this.horas_disponibles = null
			this.horas_solicitadas = 0
			this.loading = false
		},
		addPermisoDetalle () {
			if (this.$refs.form.validate()) {
				this.loading = true
				const fecha_temp = this.$moment(this.form.fecha_hasta+' '+this.time_hora_hasta).diff(this.form.fecha_desde+' '+this.time_hora_desde, 'minutes')
				if (fecha_temp > 0) {
					this.permiso_detalle.fecha_desde = this.form.fecha_desde
					this.permiso_detalle.fecha_hasta = this.form.fecha_hasta
					this.permiso_detalle.hora_desde = this.time_hora_desde
					this.permiso_detalle.hora_hasta = this.time_hora_hasta
					this.permiso_detalle.id_estado = 17
					this.permiso_detalle.delete = this.count_id++
					this.permiso_detalles.push(this.permiso_detalle)
					this.sumar_horas()
					this.permiso_detalle = {}
					this.$message.success('Detalle agregado')
					this.registro_permiso = true
					this.form.fecha_desde = new Date().toISOString().substr(0, 10),
					this.form.fecha_hasta = new Date().toISOString().substr(0, 10),
					this.time_hora_desde = null
					this.time_hora_hasta = null
				} else {
					this.$message.error('Las fechas y horas no son correctas, revise por favor')
				}
				this.loading = false
			}
		},
		deletePermisoDetalle (id) {
			let tempList = this.permiso_detalles
			for (let i = 0; i <= tempList.length; i++) {
				if (tempList[i].delete === id) {
					tempList.splice(i, 1)
					break
				}
			}
			this.permiso_detalles = tempList
			this.sumar_horas()
			this.$message.warning('Detalle eliminado')
		},
		sumar_horas () {
			let total = 0
			this.permiso_detalles.forEach(item => {
				total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
			})
			this.horas_solicitadas = total
		},
		async save () {
			this.loading = true
			this.permiso.numero = await this.obtenerMaximoNumeroTipoPermiso()
			this.permiso.id_estado = 22
			this.permiso.fecha_registro = new Date()
			this.permiso.fecha_permiso = new Date()
			const user = this.$storage.get('user')
			this.permiso.id_persona = user.id_persona
			this.$service.graphql({
				query: `
					mutation add($permiso: NewPermiso!) {
						permisoAdd(permiso: $permiso) {
							id
						}
					}
				`,
				variables: {
					permiso: this.permiso
				}
			}).then(async response => {
				if (response) {
					await this.registerPermisoDetalle(response.permisoAdd.id)
					await this.registerSeguimientoDetalle(response.permisoAdd.id, this.permiso.id_persona, this.permiso.id_estado)
					this.close()
					this.$message.success()
				}
			});
			this.loading = false
		},
		registerPermisoDetalle (id) {
			this.permiso_detalles.forEach(async item => {
				item.id_permiso = id
				delete item.delete
				await this.$service.graphql({
					query: `
						mutation add($permisoDetalle: NewPermisoDetalle!) {
							permisoDetalleAdd(permisoDetalle: $permisoDetalle) {
								id
							}
						}
					`,
					variables: {
						permisoDetalle: item
					}
				}).then(responsePermisoDetalle => {
					console.log('Ok')
				});
			})
		},
		async registerSeguimientoDetalle (id_permiso, id_persona, id_estado) {
			let seguimiento_detalle = {
				id_permiso,
				id_persona,
				id_estado,
			}
			await this.$service.graphql({
				query: `
					mutation add($seguimientoDetalle: NewSeguimientoDetalle!) {
						seguimientoDetalleAdd(seguimientoDetalle: $seguimientoDetalle) {
							id
						}
					}
				`,
				variables: {
					seguimientoDetalle: seguimiento_detalle
				}
			})
			console.log('Seguimiento registrado')
		},
		async obtenerMaximoNumeroTipoPermiso () {
			try {
				const res = await this.$service.graphql({
					query: `
						query {
							runQuery(consulta: "SELECT control.fn_secuencia_permiso(${this.permiso.id_tipo_permiso}, '${this.form.fecha_desde}')"){
								respuesta
							}
					}
					`
				})
				return res.runQuery.respuesta[0].fn_secuencia_permiso
			} catch (error) {
				console.log(error)
			}
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AddSolicitud.vue